import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Leaf } from "lucide-react";
import { toast } from "sonner";

const Signup = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Account created — welcome!");
      navigate("/", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Sign up failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] mx-auto max-w-md px-6 py-16" data-testid="signup-page">
      <div className="flex items-center gap-2 mb-6 justify-center">
        <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#2C3E2D] text-[#F9F8F6]">
          <Leaf className="h-4 w-4" />
        </span>
        <span className="font-heading text-xl text-[#2C3E2D]">Gramo<span className="text-[#E07A5F]">.</span>in</span>
      </div>
      <h1 className="font-heading text-3xl text-[#2C3E2D] text-center font-medium">Create your account</h1>
      <p className="text-sm text-[#6B7B6C] text-center mt-2">Join Gramo — fresh essentials in under 60 minutes.</p>

      <button
        onClick={handleGoogle}
        className="mt-8 w-full inline-flex items-center justify-center gap-3 rounded-full border border-[#E5E5E0] bg-white h-11 text-sm font-medium hover:border-[#81B29A] transition-colors"
        data-testid="signup-google-btn"
      >
        Continue with Google
      </button>

      <div className="flex items-center gap-3 my-6">
        <div className="h-px flex-1 bg-[#E5E5E0]" />
        <span className="text-xs uppercase tracking-widest text-[#6B7B6C]">or</span>
        <div className="h-px flex-1 bg-[#E5E5E0]" />
      </div>

      <form onSubmit={submit} className="space-y-4">
        <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required placeholder="Full name" className="h-11 rounded-xl bg-white" data-testid="signup-name" />
        <Input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} type="email" required placeholder="Email address" className="h-11 rounded-xl bg-white" data-testid="signup-email" />
        <Input value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} type="password" required minLength={6} placeholder="Choose a password" className="h-11 rounded-xl bg-white" data-testid="signup-password" />
        <Button type="submit" disabled={loading} className="btn-primary rounded-full w-full h-11" data-testid="signup-submit">
          {loading ? "Creating…" : "Create Account"}
        </Button>
      </form>
      <p className="text-sm text-center text-[#6B7B6C] mt-6">
        Already have an account? <Link to="/login" className="text-[#2C3E2D] underline underline-offset-2" data-testid="link-to-login">Sign In</Link>
      </p>
    </div>
  );
};

export default Signup;
